(function () {
  if (window.collectionReviewHighlightsLoaded) return;
  window.collectionReviewHighlightsLoaded = true;

  const sectionSelector = "[data-collection-review-highlights]";

  function initializeReviewCarousel(section) {
    if (!section || section.dataset.reviewCarouselReady === "true") return;

    const track = section.querySelector("[data-review-track]");
    const previousButton = section.querySelector("[data-review-previous]");
    const nextButton = section.querySelector("[data-review-next]");
    const cards = track ? Array.from(track.children) : [];

    if (!track || !previousButton || !nextButton || cards.length < 2) return;

    section.dataset.reviewCarouselReady = "true";
    let animationFrame;

    function getStep() {
      const firstCard = cards[0];
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(function () {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maxScroll - 2;
      });
    }

    function move(direction) {
      const reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;

      track.scrollBy({
        left: getStep() * direction,
        behavior: reducedMotion ? "auto" : "smooth",
      });
    }

    function handleKeyDown(event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;

      const direction = event.key === "ArrowRight" ? 1 : -1;
      event.preventDefault();
      move(direction);
    }

    function handleFocusIn(event) {
      const card = event.target.closest(".collection-review-highlights__card");
      if (!card || !track.contains(card)) return;

      card.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "nearest",
      });
    }

    function movePrevious() {
      move(-1);
    }

    function moveNext() {
      move(1);
    }

    previousButton.addEventListener("click", movePrevious);
    nextButton.addEventListener("click", moveNext);
    track.addEventListener("keydown", handleKeyDown);
    track.addEventListener("focusin", handleFocusIn);
    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);

    section.reviewCarouselCleanup = function () {
      window.cancelAnimationFrame(animationFrame);
      previousButton.removeEventListener("click", movePrevious);
      nextButton.removeEventListener("click", moveNext);
      track.removeEventListener("keydown", handleKeyDown);
      track.removeEventListener("focusin", handleFocusIn);
      track.removeEventListener("scroll", updateButtons);
      window.removeEventListener("resize", updateButtons);
      delete section.dataset.reviewCarouselReady;
    };

    updateButtons();
  }

  function initializeReviewCarousels(scope) {
    scope.querySelectorAll(sectionSelector).forEach(initializeReviewCarousel);
  }

  initializeReviewCarousels(document);

  // Compact collection filters replace the product grid without a section-load event.
  // Clean up removed carousels and initialize the newly rendered reviews.
  const productContainer = document.querySelector('collection-shopping')
    ?.closest('main')?.querySelector('#ProductGridContainer');
  if (productContainer) {
    let renderedSections = Array.from(productContainer.querySelectorAll(sectionSelector));
    const productObserver = new MutationObserver(function () {
      renderedSections.forEach(function (section) {
        if (!productContainer.contains(section)) section.reviewCarouselCleanup?.();
      });
      initializeReviewCarousels(productContainer);
      renderedSections = Array.from(productContainer.querySelectorAll(sectionSelector));
    });
    productObserver.observe(productContainer, { childList: true });
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeReviewCarousels(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll(sectionSelector).forEach(function (section) {
      if (typeof section.reviewCarouselCleanup === "function") {
        section.reviewCarouselCleanup();
      }
    });
  });
})();
